import { render } from "./ParallaxLoader.vue?vue&type=template&id=32117784&scoped=true"
import script from "./ParallaxLoader.vue?vue&type=script&lang=js"
export * from "./ParallaxLoader.vue?vue&type=script&lang=js"

import "./ParallaxLoader.vue?vue&type=style&index=0&id=32117784&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32117784"]])

export default __exports__